import { DateTime } from "luxon"

import { Skeleton } from "@/components/ui/skeleton"
import { numberFmt } from "@/util/numberFmt"

import { getMetricColor } from "../util/getMetricColor"

import type { MetricColorRange } from "../types/feedstockTypes"

export default function LiveDigesterMetricDisplay({
  colorRanges,
  type,
  isLoading,
  value,
}: {
  colorRanges: MetricColorRange[]
  type: "Total" | "Rate"
  isLoading: boolean
  value: number | undefined
}) {
  const prorated =
    (value || 0) /
    ((DateTime.now()
      .diff(DateTime.now().setZone("America/Chicago").startOf("day"), "hours")
      .toObject()?.hours || 0) /
      24)
  const color = getMetricColor(colorRanges, type == "Total" ? prorated : value || 0)
  return (
    <span className={color}>
      {value !== undefined ? (
        numberFmt(value)
      ) : isLoading ? (
        <Skeleton className="w-full h-[15px]" />
      ) : (
        "N/A"
      )}
    </span>
  )
}
